import INotification from "app/models/notification"

export enum Types {
  SHOW = "NOTIFICATIONS_SHOW",
  HIDE = "NOTIFICATIONS_HIDE",
  RESET = "NOTIFICATIONS_RESET",
}
export type HideAction = {
  type: Types.HIDE
  payload: { id: string }
}

export type ShowAction = {
  type: Types.SHOW
  payload: INotification
}

export type ResetAction = {
  type: Types.RESET
}

export type Action = HideAction | ShowAction | ResetAction

export function show(props: INotification): ShowAction {
  const { id, message, values, variant } = props
  return {
    payload: { id, message, values, variant },
    type: Types.SHOW,
  }
}

export function hide(id: string): HideAction {
  return {
    payload: { id },
    type: Types.HIDE,
  }
}

export function reset(): ResetAction {
  return {
    type: Types.RESET,
  }
}
